import { PlusOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { DateTime } from 'luxon';
import React, { useEffect, useRef, useState } from 'react';
import { GraphQLTaggedNode } from 'react-relay';

import { COLOR_ITEM, FORMAT_DATE_FOR_SAVE, FORMAT_TIME } from '../const';
import { ItemTaskType, TableColumnSmxType } from '../types';
import { getDefaultValueByFieldType } from './functions';
import TableEditForm from './TableEditForm';

interface IControlPanelButtonAdd {
    editableColumns: TableColumnSmxType[];
    connectionId: string;
    mutationCreate: GraphQLTaggedNode;
}

const _defaultData = {
    name: 'Task',
    color: COLOR_ITEM,
    datetime: DateTime.now().toFormat(FORMAT_DATE_FOR_SAVE),
    start_datetime: DateTime.now().toFormat(FORMAT_TIME),
    end_datetime: DateTime.now().plus({ hour: 1 }).toFormat(FORMAT_TIME),
} as ItemTaskType;

const ControlPanelButtonAdd: React.FC<IControlPanelButtonAdd> = ({ connectionId, mutationCreate, editableColumns }) => {
    const [isOpen, setIsOpen] = useState(false);
    const refButtonForm = useRef<HTMLFormElement>(null);

    useEffect(() => {}, [isOpen]);

    const showModal = () => {
        setIsOpen(true);
    };

    const handleOk = () => {
        console.log('handleOk');
        setIsOpen(false);
        refButtonForm.current?.click();
    };

    const handleCancel = () => {
        setIsOpen(false);
    };

    const handleForm = (isOk: boolean) => {
        console.log(isOk, 'handleForm');
        if (isOk) {
            setIsOpen(false);
        }
    };

    const defaultData: { [key: string]: string } = {};

    editableColumns.forEach((field) => {
        if (field.key) {
            defaultData[field.key] = getDefaultValueByFieldType(field.typeDecode);
        }
    });

    return (
        <>
            <Button icon={<PlusOutlined />} type={'primary'} onClick={showModal}>
                New record
            </Button>
            <Modal
                title={'Add'}
                open={isOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okButtonProps={{ size: 'large' }}
                cancelButtonProps={{ size: 'large' }}
                okText={'Save'}
            >
                <TableEditForm
                    handleForm={handleForm}
                    refButton={refButtonForm}
                    editableColumns={editableColumns}
                    connectionId={connectionId}
                    mutationCreateOrUpdate={mutationCreate}
                    data={defaultData}
                />
            </Modal>
        </>
    );
};

export default ControlPanelButtonAdd;
